import { ReactNode, Fragment } from 'react';
import cn from 'classnames';
import Flex from '@creditflowresearch/uilib/Flex';
import { TResponsiveValue } from '@creditflowresearch/uilib/shared/responsive-classes';

import styles from './list.module.scss';

interface IListProps<T> {
  items: T[],
  renderItem: (item: T, index: number) => ReactNode,
  gap?: TResponsiveValue<number>,
  className?: string,
  as?: 'ul' | 'ol',
}

const List = <T,>({
  items,
  renderItem,
  gap = 8,
  className,
  as = 'ul',
}: IListProps<T>) => (
  <Flex
    direction="column"
    gap={ gap }
    as={ as }
    className={ cn(styles.list, className) }
  >
    { items.map((item, index) => (
      <Fragment key={ (item as any)?.id ?? (item as any)?.key ?? index }>
        { renderItem(item, index) }
      </Fragment>
    )) }
  </Flex>
);

export default List;
